<script>
  import WhoisLookup from './WhoisLookup.svelte';
  export let name;

  let isDarkMode = localStorage.getItem('darkMode') === 'true' ? true : false;

  const toggleDarkMode = () => {
    isDarkMode = !isDarkMode;
    localStorage.setItem('darkMode', isDarkMode);
    document.documentElement.classList.toggle('dark', isDarkMode);
  };

  document.documentElement.classList.toggle('dark', isDarkMode);
</script>

<main>
  <h1>Whois Who</h1>

<svg on:click={toggleDarkMode} class="dark-button" xmlns="http://www.w3.org/2000/svg" width="4.1em" height="1em" viewBox="0 0 512 125" {...$$props}><path fill="#4A4A55" d="M166.663 96.865a26.86 26.86 0 0 1-15.304-4.324a22.17 22.17 0 0 1-8.936-11.835l9.316-3.422a17.2 17.2 0 0 0 6.084 7.367a16 16 0 0 0 9.22 2.709a13.55 13.55 0 0 0 8.792-2.661a9.23 9.23 0 0 0 3.28-7.605a8.3 8.3 0 0 0-.904-3.85a11.5 11.5 0 0 0-2.044-2.9a13.8 13.8 0 0 0-3.517-2.329q-2.378-1.186-3.944-1.806q-1.57-.615-4.61-1.663q-3.804-1.33-5.704-2.09a43 43 0 0 1-4.99-2.52a18.5 18.5 0 0 1-4.658-3.517a17 17 0 0 1-2.804-4.61a16.475 16.475 0 0 1 4.467-18.726q5.704-5.038 15.495-5.038q8.173 0 13.45 3.612a17.47 17.47 0 0 1 7.081 9.601l-9.125 3.041a10.62 10.62 0 0 0-4.42-4.895a14.85 14.85 0 0 0-7.747-1.854a11.94 11.94 0 0 0-7.462 2.091a7.02 7.02 0 0 0-2.71 5.894a6.15 6.15 0 0 0 2.091 4.563a14.4 14.4 0 0 0 4.373 2.947q2.283.95 6.94 2.566q2.85 1.047 4.229 1.569q1.379.52 4.04 1.758c1.422.63 2.79 1.377 4.087 2.234a36 36 0 0 1 3.327 2.71a14.2 14.2 0 0 1 2.9 3.468a19.4 19.4 0 0 1 1.71 4.277a19.6 19.6 0 0 1 .715 5.371q0 9.318-6.37 14.59q-6.369 5.279-16.348 5.277m60.929-1.14l-22.814-66.54h10.647l15.114 46.388a72 72 0 0 1 2.091 7.604a71 71 0 0 1 2.092-7.604l14.923-46.388h10.552l-22.72 66.54zm52.755 0v-66.54h41.255v9.316h-31.368v18.251h20.245v9.316h-20.245v20.34h33.458v9.317zm68.534 0v-66.54h9.887V86.22h32.509v9.506zm79.656-57.034v57.034h-9.887V38.69h-18.82v-9.505h47.528v9.505zm39.257 57.034v-66.54h41.255v9.316h-31.368v18.251h20.246v9.316h-20.246v20.34h33.459v9.317z"/><path fill="#FF3E00" d="M97.329 16.53C85.728-.074 62.816-4.995 46.249 5.56L17.156 24.103A33.38 33.38 0 0 0 2.075 46.46a35.15 35.15 0 0 0 3.467 22.568A33.5 33.5 0 0 0 .55 81.502a35.57 35.57 0 0 0 6.076 26.9c11.604 16.606 34.516 21.525 51.08 10.97L86.8 100.83a33.37 33.37 0 0 0 15.08-22.358a35.17 35.17 0 0 0-3.465-22.568a33.5 33.5 0 0 0 4.99-12.474a35.56 35.56 0 0 0-6.075-26.9"/><path fill="#FFF" d="M43.407 109.965a23.11 23.11 0 0 1-24.803-9.195a21.4 21.4 0 0 1-3.655-16.177q.252-1.382.695-2.717l.548-1.67l1.49 1.094a37.5 37.5 0 0 0 11.381 5.687l1.082.328l-.1 1.079a6.52 6.52 0 0 0 1.174 4.326a6.96 6.96 0 0 0 7.468 2.772a6.4 6.4 0 0 0 1.787-.786l29.095-18.54a6.06 6.06 0 0 0 2.733-4.051a6.46 6.46 0 0 0-1.101-4.876a6.96 6.96 0 0 0-7.472-2.773a6.4 6.4 0 0 0-1.784.784l-11.103 7.078a21.2 21.2 0 0 1-5.908 2.594a23.11 23.11 0 0 1-24.804-9.194a21.4 21.4 0 0 1-3.655-16.177a20.07 20.07 0 0 1 9.068-13.443l29.093-18.543a21.2 21.2 0 0 1 5.912-2.597a23.11 23.11 0 0 1 24.804 9.194a21.4 21.4 0 0 1 3.655 16.177c-.17.92-.402 1.829-.695 2.717l-.548 1.671l-1.49-1.093a37.5 37.5 0 0 0-11.382-5.689l-1.081-.328l.1-1.08a6.53 6.53 0 0 0-1.174-4.325a6.96 6.96 0 0 0-7.468-2.772a6.4 6.4 0 0 0-1.787.785L34.387 48.767a6.05 6.05 0 0 0-2.732 4.05a6.45 6.45 0 0 0 1.099 4.877a6.96 6.96 0 0 0 7.471 2.773a6.4 6.4 0 0 0 1.787-.785l11.101-7.075a21.2 21.2 0 0 1 5.908-2.596a23.11 23.11 0 0 1 24.804 9.194a21.4 21.4 0 0 1 3.655 16.177a20.08 20.08 0 0 1-9.069 13.445l-29.092 18.54a21.2 21.2 0 0 1-5.912 2.598"/></svg>

  <WhoisLookup />
</main>

<footer class="footer">
  <p>
    <a href="https://whois-who.vercel.app" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: inherit;">
      whois-who.vercel.app
    </a>
  </p>
</footer>


<style>
  :global(body) {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100vh;
    background-color: white;
    color: black;
    transition: background-color 0.3s, color 0.3s;
  }

  main {
    text-align: center;
    width: 100%;
    padding: 1em;
    box-sizing: border-box;
  }

h1 {
  font-size: 4em;
  font-weight: 100;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #e03e00, #e67e00); 
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}



  :global(.dark body) {
    background-color: #121212;
    color: white;
  }

  .whois-container {
    margin-top: 20px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px dashed #ff3e00;
    max-height: 400px;
    overflow-y: auto;
  }

  :global(.dark .whois-container) {
    background-color: #333;
    color: white;
    border-color: #ff3e00;
  }

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 14px;
  }

.dark-button {
  background-color: transparent;
  border: none;
  padding: 10px;
  cursor: pointer;
  margin-top: 20px;
  color: black;
  font-size: 1.5rem;


  display: block;
  margin-left:  auto;
  margin-right: auto;
  text-align: center;
}


  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 10px;
    font-size: 1rem;
    color: #ff3e00;
    font-weight: 100;
  }


  @media (max-width: 640px) {
    h1 {
      font-size: 2.5em;
    }

    .dark-button {
      font-size: 1rem;
      padding: 8px;
    }

    .footer {
      font-size: 0.9em;
      padding: 8px;
    }
  }

  /* Larger screens */
  @media (min-width: 640px) {
    main {
      max-width: 700px;
    }

    h1 {
      font-size: 4em;
    }
  }
</style>


